import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-silver-light" data-id="element-130" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-131" data-mp="223oejhmj3wdd">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border border-silver-light rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-132" data-mp="222n156i1ixsh">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-accent" data-id="element-133" data-mp="1j52em62r0bb1" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-ink text-white mb-8" data-id="element-134" data-mp="1ee3qwlffkaxr">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-135" data-mp="qnhk0xh5wwpc" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-136" data-mp="lp6ayoyoyq86">
            Complete <span className="text-accent" data-id="element-137" data-mp="ozjbijzwtap5">7-day guarantee</span>
          </h2>
          <div className="space-y-6 text-lg text-graphite max-w-2xl mx-auto" data-id="element-138" data-mp="oxf9k7lkmlri">
            <p data-id="element-139" data-mp="tx1oclh1sa2f">
              Open the complete system. Explore all 7 volumes. Review all 5 bonuses. Use the
              material with your athletes.
            </p>
            <p className="font-medium text-ink" data-id="element-140" data-mp="12r6awsp5ezc5">
              If you feel the material is not clear, practical or useful for your coaching needs,
              contact us within 7 days according to the guarantee terms.
            </p>
            <p className="text-accent-dark font-display font-bold text-xl" data-id="element-141" data-mp="b00hev3xnzvu">7 days to decide.</p>
            <p className="text-sm text-graphite-light mt-8" data-id="element-142" data-mp="ezsjqq2qh9sr">
              The goal is simple: you should feel that the system saves time and gives you material
              you can actually use.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}